export default "__VITE_PUBLIC_ASSET__97b3c3be__"